import React, { Component } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
  TextField,
  Chip,
  Box,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
  CircularProgress, // Importado para o loader
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { apiUrl } from "../apiUrl";
import { toast } from "react-toastify";

class MultiSelectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      busca: "",
      selecionados: [],
      tempSelecionados: [],
      data: [], // Dados da API
      loading: false, // Controle do loader
    };
  }

  // Função para buscar dados da API
  fetchItens = async () => {
    this.setState({ loading: true });
    try {
      const response = await fetch(
        `${apiUrl}/v2/equipment/list/itens/${this.props.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      );
      const res = await response.json();

      // Mapeia os dados para garantir que tenham a propriedade 'title' que o componente usa
      const dadosFormatados = res.map((item) => ({
        ...item,
        title: `${item.cat}.${item.sub}.${item.idu}`,
      }));

      this.setState({ data: dadosFormatados, loading: false });
    } catch (error) {
      console.error("Erro ao buscar itens:", error);
      this.setState({ loading: false });
    }
  };

  handleOpen = () => {
    this.setState(
      {
        open: true,
        tempSelecionados: [...this.state.selecionados],
      },
      () => {
        // Dispara o fetch somente ao abrir
        this.fetchItens();
      }
    );
  };

  handleClose = () => {
    this.setState({ open: false, busca: "" });
  };

  handleToggleTemp = (item) => {
    const { tempSelecionados } = this.state;
    const { quantity } = this.props; // Limite vindo das props

    const existe = tempSelecionados.some((s) => s.id === item.id);

    if (existe) {
      // Se já existe, removemos (desmarcar sempre é permitido)
      const novos = tempSelecionados.filter((s) => s.id !== item.id);
      this.setState({ tempSelecionados: novos });
    } else {
      // Se não existe, verificamos se ainda há espaço no limite
      if (tempSelecionados.length < quantity) {
        const novos = [...tempSelecionados, item];
        this.setState({ tempSelecionados: novos });
      } else {
        toast.warn(` Vocé pode selecionar até ${quantity} itens.`);
      }
    }
  };

  handleRemoveSelected = (item) => {
    this.setState(
      {
        selecionados: this.state.selecionados.filter((s) => s.id !== item.id),
      },
      () => {
        if (this.props.onRemove) {
          this.props.onRemove(item);
        }
      }
    );
  };

  handleConfirm = () => {
    const { tempSelecionados } = this.state;

    this.setState(
      {
        selecionados: tempSelecionados,
        open: false,
        busca: "",
      },
      () => {
        if (this.props.onSelect) {
          this.props.onSelect(tempSelecionados);
        }
      }
    );
  };

  render() {
    const { open, busca, selecionados, tempSelecionados, data, loading } =
      this.state;

    const itensFiltrados = data.filter((item) =>
      item.title.toLowerCase().includes(busca.toLowerCase())
    );

    return (
      <Box>
        <Typography
          variant="subtitle2"
          sx={{ mb: 1, color: "text.secondary", fontWeight: "bold" }}
        >
          ITENS CATEGORIA
        </Typography>

        <Paper
          variant="outlined"
          sx={{
            p: 1,
            minHeight: "56px",
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            alignItems: "center",
            backgroundColor: "#f9f9f9",
            cursor: "pointer",
            transition: "0.2s",
            "&:hover": { borderColor: "primary.main" },
            position: "relative",
            pr: 5,
          }}
          onClick={this.handleOpen}
        >
          {selecionados.length === 0 && (
            <Typography variant="body2" sx={{ color: "text.disabled", ml: 1 }}>
              Clique para selecionar...
            </Typography>
          )}

          {selecionados.map((item) => (
            <Chip
              key={item.id}
              label={item.title}
              size="small"
              color="primary"
              onDelete={(e) => {
                e.stopPropagation();
                this.handleRemoveSelected(item);
              }}
            />
          ))}

          <IconButton
            color="primary"
            sx={{ position: "absolute", right: 4, top: 8 }}
          >
            <AddCircleOutlineIcon />
          </IconButton>
        </Paper>

        <Dialog open={open} onClose={this.handleClose} fullWidth maxWidth="xs">
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Selecionar Itens
            <IconButton
              onClick={this.handleClose}
              size="small"
              disabled={loading}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers sx={{ minHeight: "200px" }}>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 5,
                }}
              >
                <CircularProgress size={40} />
                <Typography
                  sx={{ mt: 2 }}
                  variant="body2"
                  color="text.secondary"
                >
                  Carregando itens...
                </Typography>
              </Box>
            ) : (
              <>
                <TextField
                  fullWidth
                  placeholder="Pesquisar..."
                  variant="outlined"
                  size="small"
                  value={busca}
                  onChange={(e) => this.setState({ busca: e.target.value })}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />

                <List sx={{ maxHeight: 300, overflow: "auto" }}>
                  {itensFiltrados.map((item) => (
                    <ListItem key={item.id} disablePadding divider>
                      <ListItemButton
                        dense
                        onClick={() => this.handleToggleTemp(item)}
                      >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <Checkbox
                            edge="start"
                            checked={tempSelecionados.some(
                              (s) => s.id === item.id
                            )}
                            disableRipple
                          />
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                  {itensFiltrados.length === 0 && (
                    <Typography
                      variant="body2"
                      sx={{
                        p: 2,
                        textAlign: "center",
                        color: "text.secondary",
                      }}
                    >
                      Nenhum item encontrado.
                    </Typography>
                  )}
                </List>
              </>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
            <Typography variant="caption" color="text.secondary">
              {tempSelecionados.length} selecionado(s) de {this.props.quantity}
            </Typography>
            <Box>
              <Button
                onClick={this.handleClose}
                sx={{ mr: 1 }}
                disabled={loading}
              >
                Cancelar
              </Button>
              <Button
                onClick={this.handleConfirm}
                variant="contained"
                disableElevation
                disabled={
                  this.props.quantity == tempSelecionados.length ? false : true
                }
              >
                Concluir
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default MultiSelectList;
